import style from './RightContentMenu.module.scss';

import { BlockList } from './BlockList';
import { SubBlockList } from './SubBlockList';

export interface RightContentMenuProps {}

interface Props extends RightContentMenuProps {}

export function RightContentMenu(_: Props) {
    return (
        <div className={style.root}>
            <BlockList />
            <SubBlockList />
        </div>
    );
}
